// src/utils/SecureStorage.ts
const SecureStorage = {
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error("SecureStorage set error:", error);
    }
  },

  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error("SecureStorage get error:", error);
      return null;
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("SecureStorage remove error:", error);
    }
  },

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("SecureStorage clear error:", error);
    }
  },
};

export default SecureStorage;
